import http from "../http/http-config";
import { GetVWGridCoversResponse } from "../models/getVWGridCoversResponse";

export default new class getVWHealthGridCovers {
    getVWHealthGridCovers(productId, onDate, moduleId, shelterId, correlationInformation, userName, userToken, tokenType): Promise<GetVWGridCoversResponse> {
        return http.get<GetVWGridCoversResponse>("GetVWHealthGridCovers", {
            params: {
                productId,
                onDate,
                moduleId,
                shelterId,
                correlationInformation,
                userName,
                userToken,
                tokenType
            }
        }).then(response => response.data)
    }
}